
export { AllIssueComponent } from "./components/all-issue.component"
export { IssueCreaterComponent } from "./shared/issue-creater/issue-creater.component"


// WEBPACK FOOTER //
// ./src/app/modules/issues/index.ts